import { FAQPage, Question, Answer } from 'schema-dts';
import { JsonLd } from 'react-schemaorg';

export function MyFAQPage() {
  const faqData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is NFT Marketplace Development?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'NFT Marketplace Development is a series of steps that results in the creation of an NFT Marketplace and encourages the enhancement of NFT\'s usability, as well as an easier way to display digital collectibles such as works of art, photographs, music, games, memes, DeFi, MetaVerses, domain names, etc.',
        },
      },
      {
        '@type': 'Question',
        name: 'How to Create an NFT Marketplace?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'Using ready-to-use clone scripts like Opensea and Rarible, among others, makes it simple to create an NFT marketplace. If you have particular needs for your NFT marketplace platform, our skilled team of engineers will create it from the ground up.',
        },
      },
      {
        '@type': 'Question',
        name: 'Is it possible to make a huge profit by developing an NFT marketplace?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'Yes, it is. The platform levies a commission and a fee for the sale or purchase of an NFT, which is its primary business model. The overall price is reduced by the seller\'s fee and increased by the buyer\'s fee.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do you offer a custom NFT marketplace development service?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'Yes, we can adjust to your NFT marketplace project needs. We also offer a white-label NFT marketplace script that can be altered to suit your exact business requirements.',
        },
      },
      {
        '@type': 'Question',
        name: 'Why choose Beleaf as your NFT Marketplace Development Company?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'As the leading NFT Marketplace Development Company in the market, we construct NFT Marketplaces with a focus on enhanced asset security, an anti-concealed development process, efficient dispute denial, and user-customizable platforms.',
        },
      },
    ],
  };

  return <JsonLd item={faqData} />;
}

export default MyFAQPage;